import { get } from "../GenericServices";

const ExportKpi = {
  exportKpi: (data) => {
    return get(`export-kpi`, data, "blob");
  },
};

export default ExportKpi;
